// extracted by mini-css-extract-plugin
module.exports = {"root":"Select_root__tnLCk","wrapper":"Select_wrapper__KiTLX","noMargin":"Select_noMargin__IRqdS","arrow":"Select_arrow__ar8Nh","icon":"Select_icon__BaZuj"};